export default __webpack_public_path__ + "static/media/cry.49155488.mp3";